import ModalHeader from './ModalHeader';
import ModalBody from './ModalBody';
import ModalFooter from './ModalFooter';
import Modal from './Modal';

export default Modal;
export { ModalHeader, ModalBody, ModalFooter };
